var map = {
	"./ion-action-sheet.entry.js": [
		361,
		5
	],
	"./ion-alert.entry.js": [
		362,
		6
	],
	"./ion-app_8.entry.js": [
		363,
		7
	],
	"./ion-avatar_3.entry.js": [
		364,
		17
	],
	"./ion-back-button.entry.js": [
		365,
		18
	],
	"./ion-backdrop.entry.js": [
		366,
		50
	],
	"./ion-button_2.entry.js": [
		367,
		19
	],
	"./ion-card_5.entry.js": [
		368,
		20
	],
	"./ion-checkbox.entry.js": [
		369,
		21
	],
	"./ion-chip.entry.js": [
		370,
		22
	],
	"./ion-col_3.entry.js": [
		371,
		51
	],
	"./ion-datetime_3.entry.js": [
		372,
		10
	],
	"./ion-fab_3.entry.js": [
		373,
		23
	],
	"./ion-img.entry.js": [
		374,
		52
	],
	"./ion-infinite-scroll_2.entry.js": [
		375,
		53
	],
	"./ion-input.entry.js": [
		376,
		24
	],
	"./ion-item-option_3.entry.js": [
		377,
		25
	],
	"./ion-item_8.entry.js": [
		378,
		26
	],
	"./ion-loading.entry.js": [
		379,
		27
	],
	"./ion-menu_3.entry.js": [
		380,
		28
	],
	"./ion-modal.entry.js": [
		381,
		8
	],
	"./ion-nav_2.entry.js": [
		382,
		14
	],
	"./ion-popover.entry.js": [
		383,
		9
	],
	"./ion-progress-bar.entry.js": [
		384,
		29
	],
	"./ion-radio_2.entry.js": [
		385,
		30
	],
	"./ion-range.entry.js": [
		386,
		31
	],
	"./ion-refresher_2.entry.js": [
		387,
		11
	],
	"./ion-reorder_2.entry.js": [
		388,
		16
	],
	"./ion-ripple-effect.entry.js": [
		389,
		54
	],
	"./ion-route_4.entry.js": [
		390,
		32
	],
	"./ion-searchbar.entry.js": [
		391,
		33
	],
	"./ion-segment_2.entry.js": [
		392,
		34
	],
	"./ion-select_3.entry.js": [
		393,
		35
	],
	"./ion-slide_2.entry.js": [
		394,
		55
	],
	"./ion-spinner.entry.js": [
		395,
		13
	],
	"./ion-split-pane.entry.js": [
		396,
		56
	],
	"./ion-tab-bar_2.entry.js": [
		397,
		36
	],
	"./ion-tab_2.entry.js": [
		398,
		15
	],
	"./ion-text.entry.js": [
		399,
		37
	],
	"./ion-textarea.entry.js": [
		400,
		38
	],
	"./ion-toast.entry.js": [
		401,
		39
	],
	"./ion-toggle.entry.js": [
		402,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		403,
		57
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 214;
module.exports = webpackAsyncContext;